import React, { useEffect, useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import PaymentStatus from "./paymentStatus";
import {
  customerCardAdded,
  customerCardAddedSuccess,
  getCustomerCards,
} from "../../../store/charges/action";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

const SetupForm = ({
  setModalAddCustomerCard,
  cardStorageOptions,
  setClientSecret,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return null;
    }

    const { error, setupIntent } = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });
    // .then(function (result) {
    //   if (result.error) {
    //     setErrorMessage(result.error.message);
    //   }
    // });
    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
    if (setupIntent?.status === "succeeded") {
      handleCreateNewCardHelper({
        StripeSetupIntent: setupIntent.id,
        StripePaymentMethod: setupIntent.payment_method,
        StorageType: cardStorageOptions,
      });
    }
  };

  const handleCreateNewCardHelper = (card) => {
    dispatch(customerCardAdded([card]));
  };

  const { customerCardAddedApiResponse } = useSelector((state) => ({
    customerCardAddedApiResponse: state.Charges.cardAddedSuccess,
  }));
  const { loading } = useSelector((state) => ({
    loading: state.Charges.loading,
  }));
  useEffect(() => {
    if (isEmpty(customerCardAddedApiResponse)) return;
    if (customerCardAddedApiResponse.status === 200) {
      // get current url strip everything after ?

      // toast.success(customerCardAddedApiResponse.message);

      dispatch(getCustomerCards());
      setClientSecret("false");
      setModalAddCustomerCard(false);
    } else {
      // toast.error(customerCardAddedApiResponse?.message);
      // setModalAddCustomerCard(true);
    }

    dispatch(customerCardAddedSuccess([]));
  }, [customerCardAddedApiResponse]);

  useEffect(() => {
    if (isEmpty(errorMessage)) return;
    toast.error(errorMessage);
  }, [errorMessage]);

  return (
    <>
      {" "}
      <form onSubmit={handleSubmit}>
        <PaymentElement />
        <button
          disabled={!stripe || loading}
          className={"btn btn-success mt-2"}
        >
          {loading ? "Please waiting card being created" : "Submit"}
        </button>
        {/* Show error message to your customers */}
        {errorMessage && (
          <div className={"mt-2 text-danger fw-semibold text-center"}>
            {/*new line*/}
            <hr />
            {errorMessage}
          </div>
        )}
      </form>
      {/*<PaymentStatus setModalAddCustomerCard={setModalAddCustomerCard} />*/}
    </>
  );
};

export default SetupForm;
